const generatePreliminaryQuestion = data => [{
    QuestionnaireType: 'RETPREQ',
    QuestionTypeCode: 'RETCMPPQ01',
    ResponseType: 'O',
    Answer: `RETCMPPQ01${data.userFiledComplaint || 'NO'}`,
}];

const generateComplaintInformation = data => ({
    ComplaintDurationFrom: data.dateFrom,
    ComplaintDurationTo: data.dateTo,
    ComplaintDescription: data.complaintDescribe,
});

const generateQuestionsPayload = (
    QuestionTypeCode,
    ResponseType,
    Answer,
    AnswerCode,
    Explanation,
) =>
    Answer
        ? {
            QuestionnaireType: 'RETCAI',
            QuestionTypeCode,
            ResponseType,
            Answer: AnswerCode ? `${AnswerCode}${Answer}` : Answer,
            Explanation,
        }
        : undefined;

const getQuestions = data => {
    const questions = [];
    let questionSix = '';
    if (data.complaint.userFiledComplaint[0]) {
        questionSix = data.complaint.userFiledComplaint[0] === 'Y' ? 'RETCMPQRESY1' : 'RETCMPQRESN2';
    }
    let questionSeven = data.complaint.agencyDetails === '' ? '' : data.complaint.agencyDetails;
    if (data.complaint.dateFrom && data.complaint.dateTo) {
        questions.push(generateQuestionsPayload('RETCMPQS2', 'D', data.complaint.dateFrom));
        questions.push(generateQuestionsPayload('RETCMPQS3', 'D', data.complaint.dateTo));
    }
    if (data.complaint.outcomeDescription) {
        questions.push(generateQuestionsPayload('RETCMPQS4', 'T', data.complaint.outcomeDescription));
    }
    if (data.complaint.complaintDescription) {
        questions.push(generateQuestionsPayload('RETCMPQS5', 'T', data.complaint.complaintDescription));
    }
    if (questionSix) {
        questions.push(generateQuestionsPayload('RETCMPQS6', 'O', questionSix));
    }
    if (questionSeven) {
        questions.push(generateQuestionsPayload('RETCMPQS7', 'T', questionSeven));
    }
    return questions;
};

const generateAllegation = violations =>
    (violations.list || []).map(
        value => ({
            TypeCode: value,
        }),
    );

// Complainant Information
const generateEmployeeInfo = complainant => ({
    Category: '',
    PreferredLanguage: complainant.userLanguage,
    EntityType: 'ULE',
    FirstName: complainant.firstName,
    LastName: complainant.lastName,
    AddressTypeCode: 'MLG',
    Street1: complainant.address1,
    Street2: complainant.address2,
    City: complainant.city,
    Zip: complainant.zip,
    StateCode: complainant.state,
    CountryCode: 'US',
    CountyCode: complainant.county,
    Phone: complainant.phoneNumber,
    PhoneExtension: '',
    AlternatePhone: '',
    AlternatePhoneExtension: '',
    Fax: '',
    Email: complainant.emailAddress,
    AlternateEmail: '',
    PositionTitle: complainant.positionTitle,
});

// Respondent Information
const generateEmployerInfo = (respondent, custom) => ({
    EntityType: custom ? 'ULE' : 'LSE',
    LicenseNumber: respondent.ubi, // ' '
    FirstName: '',
    LastName: respondent.dba, // dba
    AddressTypeCode: 'MLG',
    Street1: respondent.street1, //street1
    Street2: respondent.street2, //street2
    City: respondent.city, //city
    Zip: respondent.zip, //zip
    StateCode: respondent.state, //state
    CountryCode: 'US',
    CountyCode: respondent.county, //county
    Phone: respondent.primaryPhone, //primaryPhone
    PhoneExtension: '',
    AlternatePhone: '',
    AlternatePhoneExtension: '',
    Fax: '',
    Email: respondent.primaryEmail, //primaryEmail
    AlternateEmail: '',
});

const getUploadedFiles = (key, context) => context.rootState[key]?.uploadedFiles;

const generateDocuments = context =>
    (getUploadedFiles(`${context.getters.moduleId}_documents_upload`, context) || []).map(
        ({
            FileName,
            FileDescription,
            FileData,
            DocumentType,
            DocumentTypeLabel,
        }) => ({
            ReferenceType: 'CMP',
            DocumentType,
            DocumentTypeLabel,
            DocumentName: FileName,
            Document: FileData,
            Comments: FileDescription,
            FileName,
            FileDescription,
        }),
    );

export default function generatePayload(data, context) {
    const appState = context.rootState.appState;
    const ClientInformation = {
        BusinessUnit: 'RET',
        ClientCode: 'WALNI',
    };

    const Attestation = [
        {
            ReferenceType: 'CMP',
            AttestationCode: 'RETATT1',
        },
    ];

    const PreliminaryQuestion = generatePreliminaryQuestion(data.complaint);
    const ComplaintInformation = generateComplaintInformation(data.complaint);
    const Allegation = generateAllegation(data.complaint);
    const ComplainantInformation = generateEmployeeInfo(data.contact, data.employer);
    const RespondentInformation = generateEmployerInfo(data.employer, appState.customEmployer);
    const Documents = generateDocuments(context);
    const Questions = getQuestions(data);

    return {
        Attestation,
        PreliminaryQuestion,
        ComplaintInformation,
        Allegation,
        ComplainantInformation: JSON.parse(JSON.stringify(ComplainantInformation)),
        RespondentInformation,
        ClientInformation,
        Questions,
        Documents,
    };
};